import { useState } from 'react';

// This component shows scrape job results with iframes in a grid
const ScrapeJobResults = ({ files = [], browserSessions = [] }) => {
  const [activeTab, setActiveTab] = useState('all');
  const [filesExpanded, setFilesExpanded] = useState(false);
  const [sessionsExpanded, setSessionsExpanded] = useState(true);
  
  // Group files by type
  const filesByType = files.reduce((acc, file) => {
    const type = file.type || 'other';
    if (!acc[type]) acc[type] = [];
    acc[type].push(file);
    return acc;
  }, {});

  // Add browser sessions to tabs
  const hasBrowserSessions = browserSessions && browserSessions.length > 0;
  
  // Get list of available types
  const fileTypes = Object.keys(filesByType);
  
  // Filter files based on active tab
  const filteredFiles = activeTab === 'all' 
    ? files 
    : activeTab === 'browser-sessions'
    ? [] // Browser sessions are handled separately
    : filesByType[activeTab] || [];

  // Get the visible file counts for each type
  const getTypeCount = (type) => {
    return (filesByType[type] || []).length;
  };

  return (
    <div className="bg-white shadow rounded-lg p-4 mt-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Crawl Results</h3>
      
      {/* Browser Sessions Section */}
      {/* {hasBrowserSessions && (
        <div className="mb-6 border border-gray-200 rounded-lg overflow-hidden">
          <div className="bg-gray-50 p-3 flex justify-between items-center cursor-pointer" 
               onClick={() => setSessionsExpanded(!sessionsExpanded)}>
            <h4 className="font-medium text-gray-900">Cloud Browser Sessions ({browserSessions.length})</h4>
            <button className="text-gray-500">
              {sessionsExpanded ? (
                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          </div>
          
          {sessionsExpanded && browserSessions.map((session) => (
            <div key={session.sessionId} className="border-t border-gray-200">
              <div className="bg-white p-3 border-b">
                <div className="flex justify-between items-center">
                  <h4 className="font-medium text-gray-900">
                    Browser Session {session.browserBaseId?.substring(0, 8)}
                  </h4>
                  <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                    session.status === 'active' 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-gray-100 text-gray-800'
                  }`}>
                    {session.status}
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  {session.startTime && `Started: ${new Date(session.startTime).toLocaleString()}`}
                  {session.endTime && ` • Ended: ${new Date(session.endTime).toLocaleString()}`}
                </p>
              </div>
              
              <div className="h-96 bg-gray-100">
                {session.liveViewLink ? (
                  <iframe
                    src={session.liveViewLink}
                    title={`Browser Session ${session.sessionId}`}
                    className="w-full h-full border-0"
                    sandbox="allow-scripts allow-same-origin allow-forms"
                    allow="fullscreen"
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-gray-400">
                    <svg className="w-12 h-12 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"></path>
                    </svg>
                    <p>Live view not available</p>
                  </div>
                )}
              </div>
              
              <div className="p-3 bg-white border-t">
                {session.liveViewLink && (
                  <a
                    href={session.liveViewLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-blue-600 hover:text-blue-800 inline-flex items-center"
                  >
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                    Open in New Window
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )} */}
      
      {/* Files Section */}
      <div className="border border-gray-200 rounded-lg overflow-hidden mb-4">
        <div className="bg-gray-50 p-3 flex justify-between items-center cursor-pointer"
             onClick={() => setFilesExpanded(!filesExpanded)}>
          <h4 className="font-medium text-gray-900">Saved Files ({files.length})</h4>
          <button className="text-gray-500">
            {filesExpanded ? (
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            )}
          </button>
        </div>
        
        {filesExpanded && (
          <div className="p-4 bg-white">
            {/* Tabs for filtering by file type */}
            <div className="border-b border-gray-200 mb-4">
              <div className="flex flex-wrap -mb-px">
                <button
                  onClick={() => setActiveTab('all')}
                  className={`mr-2 py-2 px-4 text-sm font-medium ${
                    activeTab === 'all'
                      ? 'border-b-2 border-blue-500 text-blue-600'
                      : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  All ({files.length})
                </button>
                
                {fileTypes.map(type => (
                  <button
                    key={type}
                    onClick={() => setActiveTab(type)}
                    className={`mr-2 py-2 px-4 text-sm font-medium ${
                      activeTab === type
                        ? 'border-b-2 border-blue-500 text-blue-600'
                        : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {type === 'html' && 'HTML'}
                    {type === 'reduced-level1-html' && 'Reduced HTML (L1)'}
                    {type === 'reduced-level2-html' && 'Reduced HTML (L2)'}
                    {type === 'screenshot' && 'Screenshots'}
                    {!['html', 'reduced-level1-html', 'reduced-level2-html', 'screenshot'].includes(type) && type}
                    ({getTypeCount(type)})
                  </button>
                ))}
              </div>
            </div>
            
            {filteredFiles.length === 0 ? (
              <p className="text-gray-500">No files available.</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {filteredFiles.map((file) => (
                  <div key={file.fileId} className="border border-gray-200 rounded-lg overflow-hidden">
                    {/* File info */}
                    <div className="p-3">
                      <h4 className="font-medium text-gray-900 truncate" title={file.filename}>
                        {file.filename}
                      </h4>
                      <p className="text-sm text-gray-500 truncate" title={file.url || ''}>
                        {file.url}
                      </p>
                      <div className="mt-2 flex justify-between items-center">
                        <span className="text-xs bg-blue-100 text-blue-800 font-medium px-2 py-0.5 rounded">
                          {file.type}
                        </span>
                        {file.downloadUrl && (
                          <a
                            href={file.downloadUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs text-blue-600 hover:text-blue-800"
                          >
                            Download
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ScrapeJobResults;